import SideMenu from '@/containers/side-menu/SideMenu.vue';
import EmployeeWalletCreditReport from '@/pages/employee-wallet-credit-report/EmployeeWalletCreditReport';

export default {
  path: '/report-employee-wallet-credit',
  name: 'EmployeeWalletCreditReport',
  components: {
    mainContent: EmployeeWalletCreditReport,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'report-employee-wallet-credit',
    },
    breadcrumb: {
      title: 'Vendas para Carteira',
      paths: [
        { title: 'Relatórios' },
        { title: 'Vendas para Carteira' },
      ],
    },
  },
};
